import React from 'react'
import Modal from 'components/Modal'
import Button from 'components/Button'
import {
  FilterModalContent,
  ClearFilterButton,
  FilterModalTopButtons,
} from 'style/Category.style'

const FilterModal = ({
  open,
  filters,
  attributes,
  clearFilter,
  onFilter,
  ...rest
}) => {
  return (
    <Modal show={open} title="ფილტრი" {...rest}>
      <FilterModalContent>
        <FilterModalTopButtons>
          <ClearFilterButton onClick={() => clearFilter()}>
            გასუფთავება
          </ClearFilterButton>
          <Button
            color="orange"
            onClick={() => {
              onFilter()
              if (typeof rest.onClose === 'function') {
                rest.onClose()
              }
            }}
          >
            ფილტრების შენახვა
          </Button>
        </FilterModalTopButtons>
        {filters}
      </FilterModalContent>
    </Modal>
  )
}

export default FilterModal
